// @flow
import gql from 'graphql-tag';

export const SET_MY_TALKDESK_EMAIL = gql`
  mutation setMyTalkdeskEmail($talkdeskEmail: String) {
    setMyTalkdeskEmail(talkdeskEmail: $talkdeskEmail)
  }
`;
